import { formatPrice } from 'lib/utils/helpers';

const PriceLabel = ({ price, compareAtPrice, currencyCode }) => {
  return (
    <>
      {compareAtPrice && (
        <span className="mr-1 text-[#828282] line-through">
          {formatPrice(compareAtPrice, currencyCode, 2, 2)}
        </span>
      )}
      <span className={`font-bold ${compareAtPrice ? 'text-red' : ''}`}>
        {price && formatPrice(price, currencyCode, 2, 2)}
      </span>
    </>
  );
};

export default PriceLabel;
